export const MAX_TOTAL_ROYALTY_PERCENT = 50;
